// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__QRDir","burger":"mimic___styles_burger__78idh","close":"mimic___styles_close__7lahZ"};